import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached consent data
export function useConsentsSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/consent_tracking"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
